
import AssetService from './assetService';
import LoginService from './authService';
import DeviceService from './deviceService';
import { Service } from './restService';
import DashboardService from './dashboardService';
import CustomerService from './customerService';
import UserService from './userService';

class ThingsboardServices extends Service {

    constructor(storage, errorHandler) {
        super(storage, null, null, errorHandler);

        this.getUrl = () => this.storage.getItem('thingsboard/state', 'site');
        this.getUrlCbk = () => this.storage.getItem('thingsboard/state', 'site') + '/api/';
        this.getAuthCbk = () => this.storage.getItem('thingsboard/auth', 'token');
        this.errorHandler = errorHandler;

        this.getRoutes = () => {
            return {
                home: this.getUrl() + '/home',
                assets: this.getUrl() + '/assets',
                dashboards: this.getUrl() + '/dashboards',
                devices: this.getUrl() + '/devices',
                entityViews: this.getUrl() + '/entityViews'
            }
        };

        this.services = {
            routes: this.getRoutes,
            login: new LoginService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
            asset: new AssetService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
            device: new DeviceService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
            dashboard: new DashboardService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
            customer: new CustomerService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
            user: new UserService(this.storage, this.getUrlCbk, this.getAuthCbk, this.errorHandler),
        }
    }

    getServices = () => this.services;

    setUpdateStateCbk = (callback) => {
        this.updateState = callback;
        this.services.login.setUpdateStateCbk(this.updateState);
        this.services.asset.setUpdateStateCbk(this.updateState);
        this.services.device.setUpdateStateCbk(this.updateState);
        this.services.dashboard.setUpdateStateCbk(this.updateState);
        this.services.customer.setUpdateStateCbk(this.updateState);
        this.services.user.setUpdateStateCbk(this.updateState);
    }


}

export default ThingsboardServices;